import {
  AlphabetsDraftApi,
  SharedserviceMelcoModelsUserAlphabet,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import { PublishState } from "../../../helper/publishedState";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../../table/useTableErrorComponent";
import { ServiceType } from "../../../helper/serviceType";

export const useFonts = (service: ServiceType, publishState: PublishState) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<SharedserviceMelcoModelsUserAlphabet>();

  const query = useAPIQuery(
    AlphabetsDraftApi,
    [
      "fonts",
      currentPage,
      pageSize,
      filters,
      sortBy(),
      searchQuery,
      service,
      publishState,
    ],
    async (api) => {
      const response = await api.userAlphabetSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        publishState,
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        service,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
